import { generalPolicyByTopic } from './conditions'

export const docsApproved = async ({ rootGetters }) => {
  const policy = await generalPolicyByTopic('docs', rootGetters)
  return policy.exists ? policy.required : false
}
